import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useContext,
  useEffect,
} from "react";

import { Dialog, DialogContent } from "@material-ui/core";

import { SECONDARY_COLOR, SECONDARY_COLOR_OFFLINE } from "../../../utils";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import { TextInput } from "../../../components";
import { AppContext } from "../../../app/context";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { CircularProgress, Backdrop } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          autoFocus
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const columns = ["cupomFiscal", "dataFiscal", "horaFiscal", "valor"];
const columnsLabel = ["Cupom", "Data", "Hora", "Valor"];

const DialogoConfirmacao = forwardRef(({ processando }, ref) => {
  const [transacoes, setTransacoes] = useState([]);
  const [openLocal, setOpenLocal] = useState(false);

  useImperativeHandle(ref, () => ({
    handleOpen(transacao) {
      setTransacoes(transacao);
      setOpenLocal(true);
    },
  }));

  function handleClose() {
    setOpenLocal(false);
  }

  return (
    <div>
      <Dialog
        open={processando ? true : openLocal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        disableEscapeKeyDown
        fullScreen
      >
        {/* LOADING OVERLAY */}
        <Backdrop
          open={processando}
          style={{
            zIndex: 1301, // acima do Dialog
            color: "#fff",
          }}
        >
          <CircularProgress />
        </Backdrop>
        <DialogTitle
          id="alert-dialog-title"
          style={{
            color: "white",
            backgroundColor: SECONDARY_COLOR,
            textAlign: "center",
          }}
          onClose={processando ? null : () => handleClose()}
        >
          Tratamento de Transações TEF Pendentes
        </DialogTitle>
        <DialogContent
          style={{
            margin: "0",
            padding: "10px",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffeaea",
              border: "1px solid #f44336",
              color: "#b71c1c",
              padding: "8px 12px",
              fontWeight: 600,
              borderRadius: 4,
              marginBottom: 8,
            }}
          >
            ⚠ Estas transações foram canceladas pelo TEF
          </div>
          <TableContainer component={Paper}>
            <Table size="small" style={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  {columnsLabel.map((col) => (
                    <TableCell
                      key={col}
                      style={{
                        color: "white",
                        backgroundColor: SECONDARY_COLOR,
                        //textAlign: "center",
                      }}
                    >
                      {col}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {transacoes.map((row) => (
                  <TableRow key={row.cupomFiscal}>
                    {columns.map((col) => (
                      <TableCell key={col}>{row[col]}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
});

export default DialogoConfirmacao;
